import React, { useEffect, useState } from "react";
import FilterDrawer, {
  FilterDrawerApplyButton,
  FilterDrawerCheckboxOption,
  FilterDrawerEmpty,
  FilterDrawerPill,
  FilterDrawerPills,
  FilterDrawerResetButton,
  FilterDrawerSection,
} from "../../DesignSystem/FilterDrawer/FilterDrawer";
import { getParaplanningPermissionState } from "../utils/userPermissions";
import { useUserPermissions } from "../../SignIn/UserPermissionsContext";
const CATALOG_OPTIONS = [
  {
    id: "financial_planning",
    label: "Financial Planning",
  },
  {
    id: "mortgage_protection",
    label: "Mortgage & Protection",
  },
];

const STATUS_OPTIONS = [
  {
    id: "in_progress",
    label: "In Progress",
  },
  {
    id: "completed",
    label: "Completed",
  },
];

const toggleValue = (list = [], value) => {
  if (list.includes(value)) {
    return list.filter((item) => item !== value);
  }

  return [...list, value];
};

const ParaplanningFiltersDrawer = ({
  open,
  filters,
  adviserOptions = [],
  caseTypeOptions = [],
  assignedToOptions = [],
  onClose,
  onApply,
  onReset,
}) => {
  const [draftFilters, setDraftFilters] = useState(filters);
  const { userPermissions = [] } = useUserPermissions();
  const { isAdmin } = getParaplanningPermissionState(userPermissions);

  useEffect(() => {
    setDraftFilters(filters);
  }, [filters, open]);

  const updateArrayFilter = (field, value) => {
    setDraftFilters((prev) => ({
      ...prev,
      [field]: toggleValue(prev[field] || [], value),
    }));
  };

  const resetFilters = () => {
    const emptyFilters = {
      catalogIds: [],
      adviserIds: [],
      caseTypeIds: [],
      statuses: [],
      assignedToIds: [],
    };

    setDraftFilters(emptyFilters);
    onReset?.(emptyFilters);
  };

  const applyFilters = () => {
    onApply?.(draftFilters);
    onClose?.();
  };

  return (
    <FilterDrawer
      open={open}
      title="Filters"
      onClose={onClose}
      footer={
        <>
          <FilterDrawerApplyButton onClick={applyFilters}>
            Apply Filters
          </FilterDrawerApplyButton>

          <FilterDrawerResetButton onClick={resetFilters}>
            Reset All
          </FilterDrawerResetButton>
        </>
      }
    >
      <FilterDrawerSection title="Paraplanning">
        <FilterDrawerPills>
          {CATALOG_OPTIONS.map((option) => {
            const active = draftFilters.catalogIds?.includes(option.id);

            return (
              <FilterDrawerPill
                key={option.id}
                active={active}
                onClick={() => updateArrayFilter("catalogIds", option.id)}
              >
                {option.label}
              </FilterDrawerPill>
            );
          })}
        </FilterDrawerPills>
      </FilterDrawerSection>

      <FilterDrawerSection title="Adviser">
        {adviserOptions.length ? (
          adviserOptions.map((option) => (
            <FilterDrawerCheckboxOption
              key={option.id}
              label={option.label}
              checked={draftFilters.adviserIds?.includes(option.id)}
              onChange={() => updateArrayFilter("adviserIds", option.id)}
            />
          ))
        ) : (
          <FilterDrawerEmpty>No advisers found</FilterDrawerEmpty>
        )}
      </FilterDrawerSection>

      <FilterDrawerSection title="Case Type">
        {caseTypeOptions.length ? (
          caseTypeOptions.map((option) => (
            <FilterDrawerCheckboxOption
              key={option.id}
              label={option.label}
              checked={draftFilters.caseTypeIds?.includes(option.id)}
              onChange={() => updateArrayFilter("caseTypeIds", option.id)}
            />
          ))
        ) : (
          <FilterDrawerEmpty>No case types found</FilterDrawerEmpty>
        )}
      </FilterDrawerSection>

      <FilterDrawerSection title="Status">
        {STATUS_OPTIONS.map((option) => (
          <FilterDrawerCheckboxOption
            key={option.id}
            label={option.label}
            checked={draftFilters.statuses?.includes(option.id)}
            onChange={() => updateArrayFilter("statuses", option.id)}
          />
        ))}
      </FilterDrawerSection>

      {isAdmin && (
        <FilterDrawerSection title="Assigned To">
          {assignedToOptions.length ? (
            assignedToOptions.map((option) => (
              <FilterDrawerCheckboxOption
                key={option.id}
                label={option.label}
                checked={draftFilters.assignedToIds?.includes(option.id)}
                onChange={() => updateArrayFilter("assignedToIds", option.id)}
              />
            ))
          ) : (
            <FilterDrawerEmpty>No assigned users found</FilterDrawerEmpty>
          )}
        </FilterDrawerSection>
      )}
    </FilterDrawer>
  );
};

export default ParaplanningFiltersDrawer;
